/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router/index'
import cookies from './cookies'

//正在请求令牌
window._axiosPromiseArr = []

//创建实例
let service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 60000
})
service.defaults.headers.post['Content-Type'] = 'application/json;chartset=utf-8'

//请求拦截
service.interceptors.request.use(
  config => {
    let token = cookies.get('token')
    token && (config.headers['Authorization'] = `Bearer ${token}`)
    let xtoken = cookies.get('refresh_token')
    xtoken && (config.headers['X-Authorization'] = `Bearer ${xtoken}`)

    //载入取消令牌
    config.cancelToken = new axios.CancelToken((cancel) => {
      window._axiosPromiseArr.push({ cancel })
    })

    return config
  },
  error => {
    Message.alert("请求超时！")
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    if (response.headers['access-token']) {
      cookies.set("token", response.headers['access-token'])
    }
    if (response.headers['x-access-token']) {
      cookies.set("refresh_token", response.headers['x-access-token'])
    }
    //成功后执行回调处理
    if (response.status == 200) {
      //常规返回
      if (response.headers['content-type'] == 'application/json; charset=utf-8' && response.data.Succeeded) {
        return Promise.resolve(response.data.Data)
      }
      //下载文件处理
      else if (response.headers['content-type'] == 'application/octet-stream') {
        return downfile(response) && Promise.resolve("执行成功")
      }
    }
    else {
      return Promise.reject(response.data.Errors)
    }
  },
  error => {
    if (!axios.isCancel(error)) {
      switch (error.response.status) {
        case 401: {
          //未登录
          router.replace({
            path: '/login?redirect=' + router.currentRoute.path,
          })
          break
        }
        case 403: {
          Message({
            message: `403：暂无权限访问接口！`,
            type: 'warning'
          })
          break
        }
        case 409: {
          stop()
          MessageBox.alert("账号已在其它地方登陆，请从新登录", "409", {
            center: true,
            type: 'warning',
            confirmButtonText: '重新登录',
            callback: () => {
              router.replace({
                path: '/login?redirect=' + router.currentRoute.path,
              })
            }
          })
          break
        }
        default: {
          Message({
            message: `错误：${error}`,
            type: 'error'
          })
        }
      }
    }
  }
)

/**
 * 停止其它任务的执行
 */
const stop = () => {
  if (window._axiosPromiseArr) {
    window._axiosPromiseArr.map((ele, index) => {
      ele.cancel("请求终止")
      delete window._axiosPromiseArr[index]
    })
  }
}


//文件下载处理
function downfile(res) {
  try {
    //获取文件名
    let _header = {}
    res.headers['content-disposition'].split(';').map(key => {
      let _arr = key.split('=') || []
      _header[_arr[0].trim()] = _arr[1]
    })

    //处理下载
    const blob = new Blob([res.data])
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.download = _header['filename']
    a.href = blobUrl
    a.click()
    return true
  }
  catch {
    return false
  }
}

export default service
